import { paginationSize } from '../../../constants/constants';
import { SET_DEFAULT_CONFIGURATIONS } from '../../actions';
import {
    FETCH_SUBMITTED_TO_TYPIST_START,
    FETCH_SUBMITTED_TO_TYPIST_SUCCESS,
    FETCH_SUBMITTED_TO_TYPIST_ERROR,
    SET_SUBMITTED_TO_TYPIST_FILTER,
    SET_SUBMITTED_TO_TYPIST_PAGINATION,
    VIEW_STT_VISIT_LOADING_START,
    VIEW_STT_VISIT_LOADING_END,
    RESET_STT_FILTER
} from '../../actions/mis/submittedToTypistAction';

const INIT_STATE = {
    error: "",
    loading: false,
    submitting: false,
    message: '',
    pagination: {
        currentPage: 1,
        pageSize: paginationSize,
        totalPages: 0,
        totalItems: 0,
    },
    submittedToTypist: [],
    searchFilter: {
        searchText: "",
        risId: 1,
        mipIds: [],
        modalityIds: [],
        startDate: null,
        endDate: null,
    },
    sortConditions: [{ sortBy: "priority", dataType: "STRING", sortType: "asc" }],
    skippedVisits: [],
};

const submittedToTypistReducer = (state = INIT_STATE, action) => {
    let newState;
    let index;
    let searchFilter
    switch (action.type) {
        case SET_DEFAULT_CONFIGURATIONS: {
            searchFilter = {
                ...INIT_STATE.searchFilter,
                risId: action.configurations.default_ris_id || 1,
                mipIds: action.configurations.default_mip_id ? [action.configurations.default_mip_id] : [],
                myCasesOnly: action.configurations.show_my_cases_only,
            };
            return { ...state, searchFilter };
        }
        case FETCH_SUBMITTED_TO_TYPIST_START: {
            return { ...state, error: '', message: '', loading: true };
        }
        case FETCH_SUBMITTED_TO_TYPIST_SUCCESS: {
            return { ...state, error: '', message: '', loading: false, submittedToTypist: action.submittedToTypist };
        }
        case FETCH_SUBMITTED_TO_TYPIST_ERROR: {
            return { ...state, loading: false, error: action.error, message: '' };
        }
        case SET_SUBMITTED_TO_TYPIST_PAGINATION: {
            return { ...state, pagination: action.pagination };
        }
        case SET_SUBMITTED_TO_TYPIST_FILTER: {
            newState = { ...state };
            newState.searchFilter = { ...action.payload.searchFilter }
            newState.sortConditions = action.payload.sortConditions.length > 0 ? [...action.payload.sortConditions] : []
            newState.skippedVisits = action.payload.skippedVisits.length > 0 ? [...action.payload.skippedVisits] : []
            return {
                ...newState
            }
        }
        case VIEW_STT_VISIT_LOADING_START: {
            return { ...state, loading: true };
        }
        case VIEW_STT_VISIT_LOADING_END: {
            return { ...state, loading: false };
        }
        case RESET_STT_FILTER: {
            newState = { ...state };
            newState.searchFilter.searchText = null;
            newState.searchFilter.startDate = null;
            newState.searchFilter.endDate = null;
            return { ...newState };
        }
        default:
            return state;
    }
}

export default submittedToTypistReducer;